const defaults = {
  // 根据看板
  // 结构如下, 联动组配置的 map
  // dashboardUid: [
  //   [
  //     { customModelUid: "", dashboardInfoUid: "" },
  //     { customModelUid: "", dashboardInfoUid: "" }
  //   ],
  //   [
  //     { customModelUid: "", dashboardInfoUid: "" },
  //     { customModelUid: "", dashboardInfoUid: "" }
  //   ]
  // ]
  linkGroups: {},
}

const linkGroups = {
  namespaced: true,
  state: Object.assign({}, defaults),
  mutations: {
    setLinkGroups(state, { dashboardUid, groups }) {
      window.__XM_VUE_INSTANCE.$set(state.linkGroups, dashboardUid, groups)
      // console.log("设置了联动组：", state)
    },
  },
  actions: {
    // 设置联动组信息
    setLinkGroups({ commit }, { dashboardUid, groups }) {
      commit('setLinkGroups', { dashboardUid, groups })
    },
  },
}

export default linkGroups
